<template>
<div id="app">
  <global-header/>
  <div id="globalnavi_read"></div><!-- グローバルナビ読込 -->
  <div class="breadcrumb">
		<ol> 
      <li><a href="/../index.html">HOME</a></li>
      <li v-for="crumb in breadcrumbs" :key="crumb.name">
          <router-link :to="crumb.path">{{crumb.name}}</router-link>
      </li>
		</ol>
  </div>
  <div id="wrapper" class="clearfix"><!-- wrapper -->
    <div id="sidebar" class="sp_none">
      <div id="sidebar_box">
        <item-search/>
        <router-view name="side" :categorySet="sortCategories"/>
      </div> 
    </div>
    <div id="content"><!-- コンテンツ -->
      <router-view name="mainview" :categorySet="sortCategories"/>
    </div>
  </div>
  <global-footer/>
  
  <div>
    <div id="pagetop" class="pagetop">
      <p><a href="#wrap"><img :src="baseUrl + 'img/icon-arrow-w.svg'" alt=""></a></p>
    </div>

    <!-- script type="text/javascript">
    $(document).ready(function() {
      var pagetop = $('.pagetop');
      $(window).scroll(function () {
         if ($(this).scrollTop() > 100) {
              pagetop.fadeIn();
         } else {
              pagetop.fadeOut();
              }
         });
         pagetop.click(function () {
             $('body, html').animate({ scrollTop: 0 }, 500);
                return false;
       });
     });
    </script -->
  </div><!-- topへ戻る読込 -->
</div>
</template>

<script>
  import { computed, getCurrentInstance } from 'vue';
  import { useHead } from '@vueuse/head';
  import GlobalHeader from '@/components/GlobalHeader';
  // import PartHeader from '@/components/PartHeader'; 
  import ItemSearch from '@/components/ItemSearch';
  import GlobalFooter from '@/components/GlobalFooter';

  export default {
    name: 'App',
    components: {
      GlobalHeader,
      // PartHeader,
      ItemSearch,
      GlobalFooter
    },
    setup() {
      const { proxy } = getCurrentInstance();
      useHead(computed(() => ({
        title: proxy.title,
        meta: [
          { name: 'description', content: proxy.description },
          { name: 'keywords', content: proxy.keywords }
        ]
      })));
      return {};
    },
    data: function () {
      return {
        siteName: "建設機械レンタルのサイニチ",
        defaultTitle: "商品カタログ",
        title: "商品カタログ｜建設機械レンタルのサイニチ",
        description: "建設機械レンタルのサイニチです。当社で取り扱いのある商品のカタログを掲載しています。各種性能表が掲載されており、カタログPDFファイルをダウンロードすることもできます。機種一覧からカテゴリごとに分類された商品を選択することもできますし、フリーワード検索にも対応しております。",
        keywords: "建設機械,土木機械,掘削機,バックホー,油圧ショベル,レンタカー,道路機械,解体,林業,アタッチメント,高所作業車,整地,運搬機械",
        baseUrl: process.env.BASE_URL || '/',
        categories: [],
        category_id: null,
        active_page_title: null,
        lastPageViewKey: ''
      }
    },
    computed: {
      sortCategories: function() {
        var cat = this.categories
        // id順にソート（読み込み順を守るため）
        cat.sort(function(a,b){
          let r = 0
          if(a['id'] < b['id']){r=-1}
          else if(a['id'] > b['id']){r=1}
          return r
        })

        var cat2h = {}; // idをキーにしたhash
        var mother_key = 0;
        for(var i=0;i<cat.length;i++){
          cat[i].show = false;
          cat[i].child = [];
          cat2h[cat[i].id] = cat[i];
        }
        for(i=0;i<cat.length;i++){
          mother_key = cat[i].category_id;
          if(mother_key){
            cat2h[mother_key].child.push(cat[i]);
          }
        }
        var catout = []
        for(var key in cat2h){
          if(!cat2h[key].category_id){
            catout.push(cat2h[key]);
          }
        }
        return catout;
      },
      breadcrumbs: function() {
        var bread = [{
          name: '取扱商品',
          path: '/',
          active: true
        }]
        var id = this.category_id
        var title = this.active_page_title
        var routeSpec = (this.$route && this.$route.params) ? this.$route.params.Spec : ''
        for(var i=0; i<this.sortCategories.length; i++){
          if(this.sortCategories[i].id == id){
            bread = [
              {
                name: '取扱商品',
                path: '/',
                active: false
              },
              {
                name: this.sortCategories[i].name,
                path: '/speclist/' + this.sortCategories[i].name,
                active: true
              }
            ]
            return bread
          }
          for(var j=0; j<this.sortCategories[i].child.length; j++){
            if(this.sortCategories[i].child[j].id == id){
              bread = [
                {
                  name: '取扱商品',
                  path: '/',
                  active: false
                },
                {
                  name: this.sortCategories[i].name,
                  path: '/speclist/' + this.sortCategories[i].name,
                  active: false
                },
                {
                  name: this.sortCategories[i].child[j].name,
                  path: '',
                  active: true
                },
              ]
              return bread
            }
            for(var k=0; k<this.sortCategories[i].child[j].child.length; k++){
              if(this.sortCategories[i].child[j].child[k].id == id){
                if(title && (title != "x")){
                bread = [
                  {
                    name: '取扱商品',
                    path: '/',
                    active: false
                  },
                  {
                    name: this.sortCategories[i].name,
                    path: '/speclist/' + this.sortCategories[i].name,
                    active: false
                  },
                  {
                    name: this.sortCategories[i].child[j].child[k].name,
                    path: '/list/' + this.sortCategories[i].child[j].child[k].id,
                    active: false
                  },
                  {
                    name: title,
                    path: '',
                    active: true
                  },
                ]
                }else{
                bread = [
                  {
                    name: '取扱商品',
                    path: '/',
                    active: false
                  },
                  {
                    name: this.sortCategories[i].name,
                    path: '/speclist/' + this.sortCategories[i].name,
                    active: false
                  },
                  {
                    name: this.sortCategories[i].child[j].child[k].name,
                    path: '/list/' + this.sortCategories[i].child[j].child[k].id,
                    active: true
                  }
                ]
                }
                return bread
              }   
            }
          }
        }
        if (!title && routeSpec) {
          title = routeSpec
        }
        if (title && title !== 'x') {
          bread = [
            {
              name: '取扱商品',
              path: '/',
              active: false
            },
            {
              name: title,
              path: '',
              active: true
            }
          ]
        }
        return bread
    }
    },
    methods: {
      formatPageTitle: function (title) {
        var pageTitle = title || this.defaultTitle
        if (pageTitle === this.siteName) return pageTitle
        return pageTitle + '｜' + this.siteName
      },
      setPageMeta: function (title, description, keywords) {
        if (title !== undefined) this.title = this.formatPageTitle(title)
        if (description !== undefined) this.description = description
        if (keywords !== undefined) this.keywords = keywords
        this.sendPageView()
      },
      sendPageView: function () {
        if (!this.$gtag || !this.$gtag.pageview || typeof window === 'undefined') {
          return
        }
        var pagePath = this.$route ? this.$route.fullPath : window.location.pathname
        var pageViewKey = pagePath + '|' + this.title
        if (pageViewKey === this.lastPageViewKey) {
          return
        }
        this.lastPageViewKey = pageViewKey
        this.$gtag.pageview({
          page_title: this.title,
          page_path: pagePath,
          page_location: window.location.href
        })
      }
    },
    mounted : function () {
      this.sendPageView()
      //categories
      var baseUrl = process.env.VUE_APP_URL
      if (!baseUrl) {
        console.error('[api] VUE_APP_URL is empty')
        return
      }
      var url = baseUrl + '/categories/search'
      var myToken = process.env.VUE_APP_TOKEN
      var myComId = process.env.VUE_APP_COMPANY_ID
      var params = {'limit': 1000, 'company_id': myComId}
      var myHeaders = {'Content-Type': 'application/json', 'Authorization': `Token ${myToken}` }
      console.info('[api] categories', url)
      fetch(url, {
        method: "POST",
        mode: "cors",
        headers : myHeaders,
        body: JSON.stringify(params)
      })
      .then(res => {
        if (!res.ok) {
          throw new Error('[api] categories failed: ' + res.status)
        }
        return res.json()
      })
      .then(data => {
        this.categories = data
      })
      .catch(e => console.error(e))
    },
    watch: {
      '$route': function(to) {
        this.category_id = null
        this.active_page_title = ''
        if (to && to.params) {
          if (to.params.Id) {
            this.category_id = to.params.Id
          }
          if (to.params.Spec) {
            this.active_page_title = to.params.Spec
            this.setPageMeta(to.params.Spec)
          }
          if (to.params.Name) {
            this.active_page_title = to.params.Name
            this.setPageMeta(to.params.Name)
          }
          if (to.params.Keyword) {
            this.active_page_title = '検索:' + to.params.Keyword
            this.setPageMeta(this.active_page_title)
          }
        }
      }
    }
  }
</script>
